var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M41.0525 17.4722H22.948C16.0257 17.4722 10.4141 23.0838 10.4141 30.0061C10.4141 35.3861 13.8037 39.9744 18.5638 41.7519V49.4932L25.5169 42.5401H41.0525C47.9748 42.5401 53.5865 36.9284 53.5865 30.0061C53.5865 23.0838 47.9748 17.4722 41.0525 17.4722Z","stroke":"currentColor","strokeWidth":"2","strokeLinejoin":"round","key":0}),React.createElement("rect",{"x":"32","y":"23.4644","width":"8.82485","height":"8.82485","transform":"rotate(45 32 23.4644)","stroke":"currentColor","strokeLinejoin":"round","key":1})]);
}

SVGIcon.defaultProps = {"viewBox":"0 0 64 65"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
